import { useTranslation } from 'react-i18next';
// assets
import { colors } from 'components/styles/variables';
import { useState, ChangeEvent } from 'react';

interface PriceMenuInterface {
  onSubmit: (priceMin: number, priceMax: number) => void;
}

function PriceMenu({ onSubmit }: PriceMenuInterface): JSX.Element {
  const { t } = useTranslation();
  const [minPriceNumber, setMinPriceNumber] = useState<number>(0);
  const [maxPriceNumber, setMaxPriceNumber] = useState<number>(100000);
  const [minPriceInput, setMinPriceInput] = useState<string>('');
  const [maxPriceInput, setMaxPriceInput] = useState<string>('');

  const [placeholderMin, setPlaceholderMin] = useState('Any');
  const [placeholderMax, setPlaceholderMax] = useState('$100000');

  const handleMinChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;

    if (!value) {
      return;
    }

    setMinPriceInput(`${value}`);
    setMinPriceNumber(parseInt(value, 10));
  };

  const handleMaxChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setMaxPriceInput(`${event.target.value}`);
    setMaxPriceNumber(parseInt(event.target.value, 10));
  };

  return (
    <div data-body-type-menu>
      <div className="header">
        <span>{t('priceSearch.header')}</span>
      </div>
      <div className="body">
        <div className="inputs-container">
          <input
            type="number"
            className="price-input"
            placeholder={placeholderMin}
            onFocus={(): void => {
              setPlaceholderMin('');
            }}
            onBlur={(): void => {
              setPlaceholderMin('Any');
            }}
            value={minPriceInput}
            onChange={handleMinChange}
          />
          <div className="to">TO</div>
          <input
            type="number"
            className="price-input"
            placeholder={placeholderMax}
            value={maxPriceInput}
            onFocus={(): void => {
              setPlaceholderMax('');
            }}
            onBlur={(): void => {
              setPlaceholderMax('$100000');
            }}
            onChange={handleMaxChange}
          />
        </div>
        <button
          onClick={(): void => onSubmit(minPriceNumber, maxPriceNumber)}
          className="search-button"
        >
          {t('paidLanding.search')}
        </button>
      </div>
      <style jsx>
        {`
          .header {
            padding: 17px 10px 10px 14px;
            border-bottom: 1px solid ${colors.G2};
            text-align: left;
            height: 60px;
            position: relative;
            font-size: 20px;
            font-weight: 600;
            color: ${colors.BLACK};
            background-color: white;
            border-radius: 5px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            text-align: center;
          }

          .body {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 28px 24px;
          }

          .inputs-container {
            display: flex;
            width: 100%;
            align-items: center;
            margin-bottom: 28px;
            justify-content: space-between;
          }

          input {
            width: 144px;
            caret-color: ${colors.BLACK};
            color: ${colors.BLACK};
            height: 48px;
            border-radius: 8px;
            border: solid 1px ${colors.G2};
            background-color: ${colors.G1};
            text-align: center;
            // remove default ios device box shadow on inputs
            -webkit-appearance: none;
          }

          input:focus {
            outline: none;
            background-color: white;
            border: solid 1px ${colors.BLACK};
          }

          input[type='number']::-webkit-inner-spin-button,
          input[type='number']::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          input::placeholder {
            color: ${colors.BLACK};
          }

          .to {
            font-size: 16px;
            font-weight: 700;
          }

          button {
            width: 100%;
            height: 48px;
            background-color: ${colors.ALR1};
            color: white;
            border-radius: 8px;
            font-size: 18px;
            border: none;
          }

          button:hover,
          button:focus {
            background-color: ${colors.ALR2};
          }
        `}
      </style>
    </div>
  );
}

export default PriceMenu;
